import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { EventSubHttpService } from '@sc/data-access-http-services';
import { Fitter, lang } from '@sc/data-access-models';
import { JsonListKey, StorageService } from '@sc/data-access-storage';
import { AuthService } from '@sc/feature-auth-okta';
import { FittersManagerService } from '@sc/feature-fitter-shared-libs';
import { filter, tap } from 'rxjs/operators';
import { NotificationInfos } from '../models';

@Injectable({
  providedIn: 'root',
})
export class NavBarSandboxService {
  private static readonly maxNotifStored = 50;

  private fitters: Fitter[] = [];

  constructor(
    private readonly eventHttpService: EventSubHttpService,
    private readonly authService: AuthService,
    private readonly configService: ConfigurationService,
    private readonly fittersManagerService: FittersManagerService,
    private readonly storage: StorageService
  ) {}

  getFittersByManager() {
    return this.fittersManagerService
      .getOrFetchCurrentFitters()
      .pipe(tap((fitterList) => (this.fitters = fitterList)));
  }

  subscribeToTypedDossierUpdates() {
    return this.eventHttpService
      .subscribeToUpdatedDossier()
      .pipe(filter((event) => event?.updateType?.length > 0));
  }

  subscribeToNewDossierRequestApmt() {
    return this.eventHttpService
      .subscribeToNewDossier()
      .pipe(
        filter(
          (event) =>
            !!event?.dossier?.requestAppointment && !event?.dossier?.appointment
        )
      );
  }

  storeNotifications(notifs: NotificationInfos[]) {
    this.storage.setItem(
      'fitterNotificationCenter',
      notifs.slice(0, NavBarSandboxService.maxNotifStored)
    );
  }

  getStoredNotifications() {
    return this.storage.getItem<JsonListKey, NotificationInfos>(
      'fitterNotificationCenter',
      localStorage,
      []
    );
  }

  getDossierLanguage() {
    return this.storage.getItem('dossier-language');
  }

  setDossierLanguage(dossierLanguage: lang) {
    this.storage.setItem('dossier-language', dossierLanguage);
  }

  hasPlanningAccess() {
    return this.authService.userHasFitterPlanningAccess$(
      this.configService.getConfig().id,
      this.fitters
    );
  }

  hasSettingsAccess() {
    return this.authService.userHasFitterSettingsAccess$(this.fitters);
  }

  hasSearchAccess() {
    return this.authService.userHasFitterSearchAccess$(this.fitters);
  }

  hasDashboardAccess() {
    return this.authService.userHasFitterDashboardAccess$(this.fitters);
  }
}
